export function mapGeneralStateToProps(state, props) {
    return {
        ...state,
        general: state.general,
    };
}
